import { createSelector } from 'reselect';

export const getAssistantIsOpen = createSelector(
  (state) => state.assistant.isOpen,
  (isOpen) => isOpen
);

export const getAssistantMessages = createSelector(
  (state) => state.assistant.messages,
  (messages) => messages
);

export const getAssistantIsLoading = createSelector(
  (state) => state.assistant.isLoading,
  (isLoading) => isLoading
);

export const getAssistantError = createSelector(
  (state) => state.assistant.error,
  (error) => error
);

export const getAssistantIsLoadingHistory = createSelector(
  (state) => state.assistant.isLoadingHistory,
  (isLoadingHistory) => isLoadingHistory
);

export const getAssistantPendingNavigation = createSelector(
  (state) => state.assistant.pendingNavigation,
  (pendingNavigation) => pendingNavigation
);
